import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { autoHyphen } from '@utils/common';
import { HeaderType } from '@utils/types';
import { Admin } from '@graphql/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';

type OperatorListTableRowProps = {
    header: HeaderType[];
    data: Admin;
};

const OperatorListTableRow = ({
    header = [],
    data
}: OperatorListTableRowProps) => {
    const navigate = useNavigate();
    return (
        <TableRow
            onClick={() => navigate(`/setting/sysop/detail/${data?.adminId}`)}
        >
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.createdAt
                    ? dayjs(data?.createdAt).format('YYYY-MM-DD HH:mm')
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.account || '-'}
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {data?.name || '-'}
            </TableCell>
            <TableCell $minWidth={header[3].minWidth} $width={header[3].width}>
                {data?.rank || '-'}
            </TableCell>

            <TableCell $minWidth={header[4].minWidth} $width={header[4].width}>
                {data?.cellphone ? autoHyphen(data?.cellphone) : '-'}
            </TableCell>
            <TableCell $minWidth={header[5].minWidth} $width={header[5].width}>
                {data?.latestLogin
                    ? dayjs(data?.latestLogin).format('YYYY-MM-DD HH:mm')
                    : '-'}
            </TableCell>
        </TableRow>
    );
};

export default memo(OperatorListTableRow);
